import { c as _c } from "react/compiler-runtime";
import { FlexColumn, SkeletonBlock, SkeletonLine } from "@opensea/ui-kit";
export function SalesChartTooltipSkeleton() {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <SkeletonBlock className="size-[150px] rounded-lg" />;
    t1 = <SkeletonLine className="w-1/2" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <FlexColumn className="gap-2">{t0}{t1}<FlexColumn className="gap-1"><SkeletonLine className="w-full" /><SkeletonLine className="w-full" /></FlexColumn><SkeletonLine className="w-full" /></FlexColumn>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}